/* EG Menu Fix for shrine-pro-v1-3-3 */
(function () {
  const HEADINGS = new Set(["Home Office", "Living Room", "Entryway", "Bedroom"]);
  const TOP_PICKS_TEXTS = new Set(["TOP PICKS", "Top Picks"]);

  function applyClasses(root=document) {
    // TOP PICKS → đỏ
    document.querySelectorAll('a').forEach(a => {
      if (TOP_PICKS_TEXTS.has((a.textContent || "").trim())) {
        a.classList.add('eg-top-picks');
      }
    });

    // Bốn tiêu đề → in đậm
    document.querySelectorAll('.mega-menu li > a, .mega-menu h3, .mega-menu h4, .mega-menu h5')
      .forEach(el => {
        const text = (el.textContent || "").trim();
        if (HEADINGS.has(text)) {
          el.classList.add('eg-bold-heading');
        }
      });
  }

  // Chạy khi load xong
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      applyClasses();
    });
  } else {
    applyClasses();
  }
})();
